import React, { createContext, useContext, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { TradingFormState } from './trading-form.types';
import { TradingMode } from '@shared/types';
import type {
  DefaultTemplatePolicy,
  FormInitSource
} from '@server/trading-layouts/schemas';
import { UiStatePath } from './trading-form-ui-state.hook';

export const useTradingFormContext = useFormContext<TradingFormState>;

export type AdditionalTradingFormContextType = {
  mode: TradingMode;
  chartId?: string;
  initSource: FormInitSource;
  defaultTemplatePolicy: DefaultTemplatePolicy;
  setUiState: <T>(path: UiStatePath, value: T) => void;
  getUiState: <T>(path: UiStatePath, fallback: T) => T;
};

export const AdditionalTradingFormContext = createContext<
  AdditionalTradingFormContextType | undefined
>(undefined);

export const useAdditionalTradingFormContext = () => {
  const context = useContext(AdditionalTradingFormContext);
  if (!context) throw new Error('Context not defined');

  return context;
};

type ChartProviderProps = {
  value: AdditionalTradingFormContextType;
  children: any;
};

export const AdditionalTradingFormContextProvider: React.FC<
  ChartProviderProps
> = ({ value, children }) => {
  const context: AdditionalTradingFormContextType = useMemo(() => {
    return value;
  }, [value]);

  return (
    <AdditionalTradingFormContext.Provider value={context}>
      {children}
    </AdditionalTradingFormContext.Provider>
  );
};
